import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=22962b70&scoped=true&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"
import style0 from "./Component.vue?vue&type=style&index=0&id=22962b70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22962b70",
  null
  
)

export default component.exports